import { X, Check } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

const WE_ARE = [
  "Tempio Vivo nasce da una visione cristiana evangelica.",
  "Crediamo in Gesù Cristo e nella centralità della Bibbia.",
  "Il coaching cristiano accompagna la persona nel lavoro su identità, convinzioni, decisioni, obiettivi, disciplina e abitudini.",
];

const WE_ARE_NOT = [
  "Non siamo una nuova denominazione religiosa.",
  "Non proponiamo una dottrina alternativa.",
  "Non chiediamo alle persone di lasciare la propria chiesa.",
  "Non sostituiamo pastori o sacerdoti.",
  "Non sostituiamo psicologi o psicoterapeuti.",
  "Non forniamo diagnosi o trattamenti clinici.",
];

export const WhatWeAreNot = () => (
  <section id="cosa-siamo" className="bg-[#121212] py-24 sm:py-32">
    <div className="mx-auto max-w-5xl px-6 lg:px-8">
      <SectionHeading
        eyebrow="Cosa siamo e cosa non siamo"
        title={
          <>
            Non una nuova chiesa.
            <br />
            Un metodo per vivere la fede.
          </>
        }
        testid="what-we-are-heading"
      />
      <div className="grid gap-5 md:grid-cols-2">
        <Reveal>
          <div
            data-testid="what-we-are-card"
            className="h-full rounded-sm border border-[#C9A45C]/40 bg-[#080808] p-8"
          >
            <h3 className="text-sm font-bold uppercase tracking-[0.25em] text-[#C9A45C]">
              Cosa siamo
            </h3>
            <ul className="mt-6 space-y-4">
              {WE_ARE.map((item) => (
                <li
                  key={item}
                  className="flex items-start gap-3 text-sm leading-relaxed text-[#B8B8B8]"
                >
                  <Check
                    className="mt-0.5 h-4 w-4 shrink-0 text-[#C9A45C]"
                    aria-hidden="true"
                  />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
        <Reveal delay={0.12}>
          <div
            data-testid="what-we-are-not-card"
            className="h-full rounded-sm border border-[#1B1B1B] bg-[#080808] p-8"
          >
            <h3 className="text-sm font-bold uppercase tracking-[0.25em] text-white">
              Cosa non siamo
            </h3>
            <ul className="mt-6 space-y-4">
              {WE_ARE_NOT.map((item) => (
                <li
                  key={item}
                  className="flex items-start gap-3 text-sm leading-relaxed text-[#B8B8B8]"
                >
                  <X
                    className="mt-0.5 h-4 w-4 shrink-0 text-[#8F7138]"
                    aria-hidden="true"
                  />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
